import {
  FC,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useParams } from "react-router-dom";

import { AiOutlineLogout, AiOutlineUser } from "react-icons/ai";
import "./CustomNav.scss";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/actions/auth";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { MerchantEx } from "../../models";
import { RootState } from "../../redux/rootReducers";
import { useTranslation } from "react-i18next";
import { lang } from "./../../models/index";
import Link from "../../CustomComponent/Link/Link";
import useGetwidth from "../../CustomHooks/useGetWidth";
import ThemeContext from "../../ThemeContext";

import PopUp from "../PopUp/PopUp";
import {
  NotificationIcon,
  PasswordIcon,
  SignOutLogo,
} from "../Icons/CheckOutLogo";
import NotiCard from "../../screens/Notifications/NotiCard";
import {
  detectBase64ImageType,
  handleLangugeDirection,
  languageChoose,
} from "../commonFunctions";
import { flattenArrayToObject } from "../../utils/helperFunctions";

interface Props {
  type?: string | any;
  icon?: any;
  role?: string;
  toggleMainMenu?: () => void;
  accountLogo?: any;
  otpStatus?: string | any;
  toggleMenuWidth?: boolean | any;
}

export const changeLanguage = (lang: any) => {
  return () => {
    localStorage.setItem("lang", lang);
    window.location.reload();
  };
};

const notiArray = [
  {
    type: "warning",
    title: "Warning",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    time: "7mins ago",
    isread: true,
  },
  {
    type: "danger",
    title: "danger",
    text: "Hi",
    time: "7mins ago",
    isread: true,
  },
  {
    type: "danger",
    title: "danger",
    text: "Hi",
    time: "7mins ago",
    isread: false,
  },
];

const CustomNav: FC<Props> = ({
  otpStatus,
  role,
  toggleMainMenu,
  type,
  toggleMenuWidth,
}) => {
  const authApi = useSelector((state: RootState) => state.authReducer);
  const merchantApi: {
    merchantData: MerchantEx;
    loading: boolean;
    error: null | string;
    merch_id: string;
  } = useSelector((state: RootState) => state.merchantReducer);
  const PartnerApi: {
    partnerData: any;
    loading: boolean;
    error: null | string;
    partnerId: string;
  } = useSelector((state: RootState) => state.partnerReducer);

  const [active, setactiveLink] = useState("admin/SoftposDashboard");
  const themes = useContext(ThemeContext);
  const otpApi = useSelector((state: RootState) => state.otpReducer);
  const { width } = useGetwidth();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation("translation", { keyPrefix: "mainMenu" });
  const [showDropDown, setDropDown] = useState(false);
  const [menuWidth, setmenuWidth] = useState(true);
  const { merchantId }: any = useParams();
  const [showNotificationPopup, setshowNotificationPopup] = useState(false);
  const [signOutpopUp, setSignOutPopUp] = useState(false);
  const [hoverable, setHoverable] = useState(
    localStorage.getItem("hoverable") || null,
  );
  const [hasUnreadNfotiication, setHasUnreadNOtification] = useState(
    notiArray.some((notification) => !notification.isread),
  );

  const toggleDropDown = () => {
    setDropDown(!showDropDown);
  };

  const toggleNotiDropDown = () => {
    setshowNotificationPopup(!showNotificationPopup);
  };

  const handleMenuSize = () => {
    setmenuWidth(!menuWidth);
  };

  const isPayByLinkEnabledForCurrentMerchant =
    merchantApi?.merchantData?.payByLinkEnabled;
  const isRecurringEnabledForCurrentMerchant =
    merchantApi?.merchantData?.recurringEnabled;

  // Find the logged-in partner first, then extract projects
  const otpPartnerId =
    otpApi.data?.partnerBranding?.partnerId ?? otpApi.data?.partner?.partnerId;
  const loggedInPartner =
    themes?.partners?.find(
      (partner: any) => partner?.partnerId === authApi?.partnerId,
    ) ??
    themes?.partners?.find(
      (partner: any) => partner.partnerId === otpPartnerId,
    );

  const projects = useMemo(() => {
    if (loggedInPartner?.projects) {
      return flattenArrayToObject(loggedInPartner.projects, "name", "enabled");
    }
    return themes?.projects || {};
  }, [authApi.role, loggedInPartner, themes?.projects]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  const navnarLogo = useCallback(() => {
    if (role === "admin") {
      return (
        <img
          src={detectBase64ImageType(themes?.loginPagelogo)}
          loading="lazy"
          alt="Logo"
          className="Edfapay-circle"
        />
      );
    } else if (role === "partner" && PartnerApi.partnerData?.logo) {
      return (
        <img
          src={detectBase64ImageType(PartnerApi.partnerData?.logo)}
          loading="lazy"
          alt="Logo"
          className="Edfapay-circle"
        />
      );
    } else if (role === "merchant" && merchantApi.merchantData?.logo) {
      return (
        <img
          src={detectBase64ImageType(merchantApi.merchantData?.logo)}
          loading="lazy"
          alt="Logo"
          className="Edfapay-circle"
        />
      );
    }
  }, [role, merchantApi.merchantData, PartnerApi.partnerData]);

  useEffect(() => {
    if (
      location.pathname.toLowerCase() ===
        `/merchant/${merchantApi.merch_id}`.toLowerCase() ||
      location.pathname.includes("SoftposDashboard")
    ) {
      setactiveLink("softpos");
      localStorage.setItem("proj", "softpos");
    } else if (
      location.pathname.toLowerCase().includes("createInvoice".toLowerCase())
    ) {
      setactiveLink("createInvoice");
      localStorage.setItem("proj", "Invoice");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("/paymentGateway/Dashboard".toLowerCase()) ||
      location.pathname.includes("PaymentGatewayDashboard")
    ) {
      setactiveLink("paymentDashboard");
      localStorage.setItem("proj", "payment");
    } else if (
      location.pathname.toLowerCase().includes("/allDashboard".toLowerCase())
    ) {
      setactiveLink("All");
      localStorage.setItem("proj", "allDashboard");
    }
  }, [location.pathname]);

  const renderSignOutPopUp = useMemo(() => {
    if (!signOutpopUp) return null;
    const renderBody = () => {
      return <div>{t("buttons.logMess")}</div>;
    };

    return (
      <div className="signoutPopup">
        <PopUp
          isOpen={signOutpopUp}
          onClose={() => setSignOutPopUp(false)}
          header={t("buttons.logout")}
          body={() => renderBody()}
          closeButton={true}
          actionButtons={
            <div className="di-fl">
              <button
                className="button-secondary-lightGreen"
                onClick={() => {
                  setSignOutPopUp(false);
                }}
              >
                {t("buttons.cancel")}
              </button>
              <button
                className="button-primary-light"
                onClick={() => {
                  setSignOutPopUp(false);
                  dispatch(logout(authApi.token, authApi.refreshToken));
                  navigate("/login");
                }}
              >
                <SignOutLogo />
                {t("buttons.logout")}
              </button>
            </div>
          }
        />
      </div>
    );
  }, [signOutpopUp]);

  const renderNotification = () => {
    return (
      <div className="logo-container" style={{ height: "unset" }}>
        <div className="logo-element">
          <div
            className={`search ${hasUnreadNfotiication ? "unread" : "read"}`}
          >
            {hasUnreadNfotiication && <div className="circleN"></div>}
            <p>
              {" "}
              <NotificationIcon color={"#8B97A3"} />{" "}
            </p>
          </div>
        </div>
        <div
          className="dropdown-container dropdown__notif"
          style={handleLangugeDirection(lang, "dropdown__notifStyle")}
        >
          <div className="notificationPopup">
            <div className="title">
              <span>Notifications </span>
              <span>(2)</span>
            </div>
            <div
              onClick={() => {
                navigate(`merchant/${merchantApi.merch_id}/viewnotifications`);
              }}
            >
              {" "}
              {notiArray.map((item, index) => {
                return <NotiCard data={item} isActive={false} />;
              })}
            </div>

            <div
              className="viewAll"
              onClick={() => {
                navigate(`merchant/${merchantApi.merch_id}/viewnotifications`);
              }}
            >
              View All{" "}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderLogo = () => {
    const redirect = () => {
      switch (authApi.role) {
        case "admin":
          navigate(`/profile`);
          break;
        case "partner":
          navigate(`/partner/${authApi.partnerId}/profile`);
          break;
        case "merchant":
          navigate(`/merchant/${merchantApi.merch_id}/profile`);
          break;
      }
    };
    return (
      <div className="logo-container">
        <div className="logo-element">
          {navnarLogo()}

          <p className="text">
            <span className="d-inline-blck mx-2">
              {authApi.accountName /* uthApi.username */}
            </span>
            {showDropDown ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
          </p>
        </div>
        <div
          className="dropdown-container dropdown__window"
          style={handleLangugeDirection(lang, "dropdown__window")}
        >
          <div className="logo-dropdown-menu ">
            <div className="dropdown-menu-elements">
              <p className="dropdown-menu-element" onClick={() => redirect()}>
                <span className="icon">
                  {" "}
                  <AiOutlineUser />
                </span>
                <span className="text"> {t("main.profile")} </span>
              </p>
              {authApi?.role != "admin" && (
                <p
                  className="dropdown-menu-element"
                  onClick={() => {
                    navigate("/resetPasswordScreen");
                  }}
                >
                  <span className="icon">
                    {" "}
                    <PasswordIcon color={themes.MainGreenColorHexa} />
                  </span>
                  <span className="text"> {t("main.changePassword")} </span>
                </p>
              )}
              <p
                className="dropdown-menu-element"
                onClick={() => {
                  setSignOutPopUp(true);
                }}
              >
                <span className="icon">
                  <AiOutlineLogout />
                </span>
                <span className="text"> {t("main.logout")}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const changeActiveLink = (linkName: string) => {
    setactiveLink(linkName);
  };

  const HandleShowDropdown = (type: string) => {
    const dropdownWindow = document.querySelector(
      ".dropdown__window",
    ) as HTMLElement;
    if (type === "click") {
      dropdownWindow.classList.toggle("dropdown__window--active");
      toggleDropDown();
    } else {
      dropdownWindow.classList.remove("dropdown__window--active");
      setDropDown(false);
    }
  };

  const HandleNotif = (type: string) => {
    const dropdownWindow = document.querySelector(
      ".dropdown__notif",
    ) as HTMLElement;
    if (type === "click") {
      dropdownWindow.classList.toggle("dropdown__notif--active");
      toggleNotiDropDown();
    } else {
      dropdownWindow.classList.remove("dropdown__notif--active");
      setshowNotificationPopup(false);
    }
  };

  const MenuIconRender = useMemo((): any => {
    var expand = (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 21V3M3 12H17M17 12L10 5M17 12L10 19"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    );
    var collapse = (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 3V21M21 12H7M7 12L14 19M7 12L14 5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    );

    const handlingLanguagecollapseExpand = (langVal: boolean): any => {
      if (!toggleMenuWidth && width > 700) {
        return langVal ? expand : collapse;
      } else if (toggleMenuWidth && width > 700) {
        return langVal ? collapse : expand;
      } else {
        return (
          <svg viewBox="0 0 24 24">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 7a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1zm0 5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1zm1 4a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3z"
              ></path>
            </g>
          </svg>
        );
      }
    };
    return handleLangugeDirection(
      lang,
      "expandCollapse",
      handlingLanguagecollapseExpand,
    );
  }, [toggleMenuWidth]);

  const Nav = useMemo(() => {
    const checkout =
      location.pathname.includes("merchant/checkout") ||
      location.pathname.includes("invoicePayment") ||
      location.pathname.includes("purchase") ||
      location.pathname.includes("register") ||
      location.pathname.includes("Edfapay/Reciept") ||
      location.pathname.includes("transactions/Reciept") ||
      location.pathname.includes("reconciliation/receipt");
    if (
      (!checkout && otpStatus === "success") ||
      (checkout && otpStatus === "success")
    ) {
      if (role === "admin") {
        return (
          <div id="navbar-container" className="">
            <div
              className="navbar-elements"
              id="navbar-elements" /* style={{ gridTemplateColumns: "90px calc(100% - 90px)" }} */
            >
              <div className="logo-container">
                <div className="toggle-button" onClick={toggleMainMenu}>
                  <span>{MenuIconRender}</span>
                </div>
                <div className="logo">
                  {
                    <>
                      {(projects?.softPos || authApi?.role === "admin") && (
                        <Link
                          type={"link"}
                          to={`/admin/SoftposDashboard`}
                          onClick={() => {
                            changeActiveLink("softpos");
                          }}
                          className={`link-element  ${
                            active === "softpos" && `active `
                          } `}
                        >
                          <span> {t("main.softPos")} </span>
                        </Link>
                      )}

                      {(projects?.paymentGateway ||
                        authApi?.role === "admin") && (
                        <Link
                          type={"link"}
                          to={`${
                            merchantApi.merch_id
                              ? `/merchant/${merchantApi.merch_id}/paymentGateway/Dashboard`
                              : "/admin/PaymentGatewayDashboard"
                          }`}
                          onClick={() => {
                            changeActiveLink("paymentDashboard");
                          }}
                          className={`link-element  ${
                            active === "paymentDashboard" && `active `
                          } `}
                        >
                          <span> {t("main.Pay&Inv")} </span>
                        </Link>
                      )}
                    </>
                  }
                </div>
              </div>
              <div className="logo-container">
                <div className="navbar-logo-element">
                  <div
                    className="account-container dropdown dropdown__open"
                    tabIndex={0}
                    onClick={() => {
                      HandleShowDropdown("click");
                    }}
                    onBlur={() => {
                      HandleShowDropdown("blur");
                    }}
                  >
                    <div className="icon-container">{renderLogo()}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      } else if (role === "partner") {
        return (
          <div id="navbar-container" className="">
            <div className="navbar-elements" id="navbar-elements">
              <div className="logo-container">
                <div className="toggle-button" onClick={toggleMainMenu}>
                  <span>{MenuIconRender}</span>
                </div>
                <div className="logo">
                  {
                    <>
                      {projects?.softPos && (
                        <Link
                          type={"link"}
                          to={`/partner/SoftposDashboard/${authApi?.partnerId}`}
                          onClick={() => {
                            changeActiveLink("softpos");
                          }}
                          className={`link-element  ${
                            active === "softpos" && `active `
                          } `}
                        >
                          <span> {t("main.softPos")} </span>
                        </Link>
                      )}

                      {projects?.paymentGateway && (
                        <Link
                          type={"link"}
                          to={`/partner/PaymentGatewayDashboard/${authApi?.partnerId}`}
                          onClick={() => {
                            changeActiveLink("paymentDashboard");
                          }}
                          className={`link-element  ${
                            active === "paymentDashboard" && `active `
                          } `}
                        >
                          <span> {t("main.Pay&Inv")} </span>
                        </Link>
                      )}
                    </>
                  }
                </div>
              </div>
              <div className="logo-container">
                <div className="navbar-logo-element">
                  {/* <div className="lang-terms">{languageChoose()}</div> */}
                  <div
                    className="account-container dropdown dropdown__open"
                    tabIndex={0}
                    onClick={() => {
                      HandleShowDropdown("click");
                    }}
                    onBlur={() => {
                      HandleShowDropdown("blur");
                    }}
                  >
                    <div className="icon-container">{renderLogo()}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      } else if (
        role === "merchant" ||
        role === "user" ||
        role === "supervisor"
      ) {
        return (
          <div id="navbar-container" className="">
            <div className="navbar-elements" id="navbar-elements">
              <div className="logo-container">
                <div className="toggle-button" onClick={toggleMainMenu}>
                  <span>{MenuIconRender}</span>
                </div>
                <div className="logo">
                  {merchantApi.merch_id && (
                    <>
                      {projects?.softPos && projects?.paymentGateway && (
                        <Link
                          type={"link"}
                          to={`/merchant/${merchantApi.merch_id}/allDashboard`}
                          onClick={() => {
                            changeActiveLink("All");
                          }}
                          className={`link-element  ${
                            active === "All" && `active `
                          } `}
                        >
                          <span> {t("main.all")} </span>
                        </Link>
                      )}

                      {projects?.softPos && (
                        <Link
                          type={"link"}
                          to={`/merchant/${merchantApi?.merch_id}`}
                          onClick={() => {
                            changeActiveLink("softpos");
                          }}
                          className={`link-element  ${
                            active === "softpos" && `active `
                          } `}
                        >
                          <span> {t("main.softPos")} </span>
                        </Link>
                      )}
                      {projects?.invoicing &&
                        (isPayByLinkEnabledForCurrentMerchant ||
                          isRecurringEnabledForCurrentMerchant) && (
                          <Link
                            type={"link"}
                            to={`/merchant/${merchantApi.merch_id}/Invoice/createInvoice`}
                            onClick={() => {
                              changeActiveLink("createInvoice");
                            }}
                            className={`link-element  ${
                              active === "createInvoice" && `active `
                            } `}
                          >
                            <span> {t("main.invoice")} </span>
                          </Link>
                        )}
                      {projects?.paymentGateway && (
                        <Link
                          type={"link"}
                          to={`/merchant/${merchantApi?.merch_id}/paymentGateway/Dashboard`}
                          onClick={() => {
                            changeActiveLink("paymentDashboard");
                          }}
                          className={`link-element  ${
                            active === "paymentDashboard" && `active `
                          } `}
                        >
                          <span> {t("main.payment")} </span>
                        </Link>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="logo-container">
                <div className="navbar-logo-element">
                  {/* <div className="lang-terms">{languageChoose()}</div> */}

                  <div
                    className="account-container dropdown dropdown__open"
                    tabIndex={0}
                    onClick={() => {
                      HandleShowDropdown("click");
                    }}
                    onBlur={() => {
                      HandleShowDropdown("blur");
                    }}
                  >
                    <div className="icon-container">{renderLogo()}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
    } else {
      return <> </>;
    }
  }, [
    otpStatus,
    merchantApi.merch_id,
    merchantId,
    active,
    PartnerApi.partnerId,
    themes,
    toggleMenuWidth,
  ]);

  return (
    <>
      {Nav}
      {renderSignOutPopUp}
    </>
  );
};

export default CustomNav;
